import { render, staticRenderFns } from "./TrainerFormModal.vue?vue&type=template&id=6a506c01"
import script from "./TrainerFormModal.vue?vue&type=script&lang=js"
export * from "./TrainerFormModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports